import styled from 'styled-components';
import { IThemeProps } from 'component/theme';

export interface IStyledSVGIconProps {
  color?: string;
  kind?: 'primary' | 'secondary';
  [key: string]: any;
}

interface IStyledIcon {
  styleIcon?: {
    fontSize?: string,
    color?: string,
    marginTop?: string,
    width?:any,
    height?:any,
    marginRight?: any,
    backgroundColor?: string,
  }
}

export const StyledSVGIcon = styled.svg<IStyledSVGIconProps & IThemeProps>`
  ${({ theme, color, kind = 'primary' }) => `
    & *:not([fill])  {
      fill: ${!!color ? color : (kind === 'primary' || kind === undefined) ? theme.uptimeColors.generalColors.icon.enabled : theme.uptimeColors.generalColors.icon.secondary};
    }
  `}
`;

export const StyledIcon = styled.div<IStyledIcon>`
  ${({ theme, styleIcon }) => `
    width: ${styleIcon?.width ? `${styleIcon.width}px`:`${theme.uptimeSpace[20]}px`};
    height: ${styleIcon?.height ? `${styleIcon.height}px`:`unset`};
    font-size:${styleIcon?.fontSize ? `${styleIcon.fontSize}px`:`${theme.uptimeSpace[0]}px`};
    line-height: 1;
    margin-right: ${styleIcon?.marginRight ? `${styleIcon.marginRight}px`:'unset'};
    background-color: ${styleIcon?.backgroundColor ? styleIcon.backgroundColor : 'unset'} !important;
    svg {
      width: ${styleIcon?.width ? `${styleIcon.width}px` : 'unset'};
      font-size: ${styleIcon?.fontSize ? `${styleIcon.fontSize}px`:'unset'};
      color: ${styleIcon?.color ? styleIcon.color : 'unset'};
      margin-top: ${styleIcon?.marginTop ? `${styleIcon.marginTop}px`:'unset'};
    }
  `}
`;
